import React, { useState, useRef, useEffect, useDeferredValue } from "react";
import { Checkbox, Input } from "antd";
import { AiFillCaretUp, AiFillCaretDown } from "react-icons/ai";
import { GrPowerReset } from "react-icons/gr";
import "./NamedSelectComponent.css";
import { emptySearch } from "../../../toolkit/slices/inventories/inventorySlice";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "@material-ui/core";
function NamedSelectComponent({
  title,
  selectedItems,
  setSelectedItems,
  options,
}) {
  const [showOptions, setShowOptions] = useState(false);
  const [filterText, setFilterText] = useState("");
  const selectFilterRef = useRef(null);
  const isMobile = useMediaQuery("(max-width:769px)");
  const dispatch = useDispatch();
  // const handleCheckboxChange = (value) => {
  //     dispatch(emptySearch())
  //     let newSelectedItems;
  //     if (selectedItems.some(item=>new RegExp(item,'i').test(value))) {
  //         newSelectedItems = selectedItems.filter(item => item !== value);
  //     } else {
  //         newSelectedItems = [...selectedItems, value.trim()];
  //     }
  //     setSelectedItems(newSelectedItems);
  // };
  const handleCheckboxChange = (value) => {
    dispatch(emptySearch());
    let newSelectedItems;
    if (
      selectedItems.some(
        (item) => item.toLowerCase() === value.trim().toLowerCase()
      )
    ) {
      newSelectedItems = selectedItems.filter(
        (item) => item.toLowerCase() !== value.trim().toLowerCase()
      );
    } else {
      newSelectedItems = [...selectedItems, value.trim()];
    }
    setSelectedItems(newSelectedItems);
  };
  const handleClearAll = () => {
    setSelectedItems([]);
    setFilterText("");
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        selectFilterRef.current &&
        !selectFilterRef.current.contains(event.target)
      ) {
        setShowOptions(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectFilterRef]);

  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(filterText.toLowerCase())
  );
  const handleClick = () => {
    if (!isMobile) {
      setShowOptions(!showOptions);
    }
  };
  return (
    <div
      className="named-select-filter"
      ref={selectFilterRef}
      onClick={handleClick}
    >
      <div style={{ fontWeight: 600, color: "black" }}>{title}</div>
      <div style={{ display: isMobile ? "none" : "block" }}></div>
      <div style={{ display: isMobile ? "none" : "block" }}>
        <div style={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
          {selectedItems.length > 0 && <div>({selectedItems.length})</div>}
          {showOptions ? (
            <AiFillCaretUp style={{ color: "gray" }} />
          ) : (
            <AiFillCaretDown />
          )}
        </div>
      </div>
      <div id="Pc">
        {showOptions && (
          <div
            className="named-select-filter-options"
            onClick={(e) => e.stopPropagation()}
          >
            <Input
              placeholder="Type to filter"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
              style={{ marginBottom: "0.1rem" }}
            />
            <div
              style={{
                color: "#0dbaff",
                fontSize: "12px",
                cursor: "pointer",
                marginLeft: "auto",
                width: "fit-content",
              }}
              onClick={handleClearAll}
            >
              Clear All
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "1rem",
                gap: "0rem",
              }}
            >
              {filteredOptions.map((option, index) => (
                <div
                  key={option.value}
                  onClick={() => handleCheckboxChange(option.value)}
                >
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    {option.label}

                    <Checkbox
                      onChange={() => handleCheckboxChange(option.value)}
                      checked={selectedItems.includes(option.value)}
                    />
                  </div>
                  {index !== filteredOptions?.length - 1 && (
                    <hr
                      style={{
                        opacity: "1",
                        backgroundColor: "#bdbdbd",
                        border: "none",
                        height: "1px",
                        marginBottom: "0.5rem",
                      }}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div id="Mobile">
        <div
          className="named-select-filter-options"
          onClick={(e) => e.stopPropagation()}
        >
          <Input
            placeholder="Type to filter"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            style={{ marginBottom: "0.1rem" }}
          />
          <div
            style={{
              color: "#0dbaff",
              fontSize: "12px",
              cursor: "pointer",
              marginLeft: "auto",
              width: "fit-content",
            }}
            onClick={handleClearAll}
          >
            Clear All
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              marginTop: isMobile ? "0rem" : "1rem",
              gap: "0rem",
            }}
          >
            {filteredOptions.map((option) => (
              <div
                key={option.value}
                onClick={() => handleCheckboxChange(option.value)}
                style={{
                  backgroundColor: isMobile
                    ? selectedItems.includes(option.value)
                      ? "rgba(255, 203, 16, 1)"
                      : "rgba(239, 239, 239, 1)"
                    : "transparent",
                }}
                id="OptionsValues"
              >
                {option.label}
                <Checkbox
                  style={{ display: "none" }}
                  onChange={() => handleCheckboxChange(option.value)}
                  checked={selectedItems.includes(option.value)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default NamedSelectComponent;
